/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { StringItem } from '../../models/string-item';

export interface DdtControllerPreviewEmailBody$Params {
  id: number;
}

export function ddtControllerPreviewEmailBody(http: HttpClient, rootUrl: string, params: DdtControllerPreviewEmailBody$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerPreviewEmailBody.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: StringItem;
      }>;
    })
  );
}

ddtControllerPreviewEmailBody.PATH = '/ddt/{id}/preview-body';
